import { SQLModule } from './types';

export const phase4Modules: SQLModule[] = [
  {
    id: "sql-phase4-1",
    title: "Enterprise Database Architecture",
    description: "Design and implement enterprise-scale database architectures",
    order: 1,
    content: `
# Enterprise Database Architecture

## Scalability Patterns
Learn proven patterns for scaling databases horizontally and vertically.

## High Availability Design
Implement robust high-availability solutions for mission-critical systems.

## Security Architecture
Design comprehensive security frameworks for enterprise databases.
    `,
    estimatedTime: 120,
    duration: "120 minutes",
    difficulty: "expert",
    prerequisites: ["Advanced SQL knowledge", "Database administration experience"],
    tags: ["enterprise", "architecture", "scalability", "security"]
  },
  {
    id: "sql-phase4-2",
    title: "Data Warehousing and ETL Processes",
    description: "Master data warehousing concepts and ETL processes",
    order: 2,
    content: `
# Data Warehousing and ETL Processes

## Data Warehouse Design
Learn to design efficient data warehouses for analytical workloads.

## ETL Pipeline Development
Build robust ETL pipelines for data integration.

## Data Quality Management
Implement data quality checks and validation procedures.
    `,
    estimatedTime: 100,
    duration: "100 minutes",
    difficulty: "advanced",
    prerequisites: ["Advanced SQL knowledge", "Data modeling experience"],
    tags: ["data-warehousing", "etl", "data-quality"]
  },
  {
    id: "sql-phase4-3",
    title: "NoSQL Database Integration",
    description: "Integrate SQL databases with NoSQL systems",
    order: 3,
    content: `
# NoSQL Database Integration

## Polyglot Persistence
Understand the principles of polyglot persistence.

## Data Migration Strategies
Develop strategies for migrating data between SQL and NoSQL databases.

## Hybrid Data Models
Design hybrid data models that combine the strengths of SQL and NoSQL.
    `,
    estimatedTime: 110,
    duration: "110 minutes",
    difficulty: "expert",
    prerequisites: ["SQL knowledge", "NoSQL experience"],
    tags: ["nosql", "integration", "polyglot-persistence"]
  }
];
